import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/toastSeguro";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { applyFleetBranding } from "@/config/productConfig";

applyFleetBranding();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// ---------------------------------------------------------------------------
// Service Worker registration
// ---------------------------------------------------------------------------
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((registration) => {
        console.log("[SW] Registado com sucesso. Scope:", registration.scope);

        // Notificar quando uma nova versão estiver disponível
        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // Há uma nova versão disponível — pode-se avisar o utilizador
              console.log("[SW] Nova versão disponível. Recarregue para actualizar.");
            }
          });
        });
      })
      .catch((err) => {
        console.warn("[SW] Registo falhou:", err);
      });
  });
}

// ---------------------------------------------------------------------------
// PWA install prompt — guardar o evento para usar na UI
// ---------------------------------------------------------------------------
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
  // Disparar evento custom para que componentes React possam ouvir
  window.dispatchEvent(new CustomEvent("pwa-installable"));
});

window.addEventListener("appinstalled", () => {
  window.__pwaInstallPrompt = null;
  window.dispatchEvent(new CustomEvent("pwa-installed"));
  console.log("[PWA] App instalada com sucesso.");
});
